// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { SkeletonTokens } from './type';

const skeletonTokens: SkeletonTokens = {
  skeletonMargin: 'Spacing-12',
  skeletonHeight: 'Size-8',
  skeletonBackgroundColor: 'Neutral-fill-2',
  skeletonBackgroundRadius: 'Radius-default',
  skeletonButtonMarginTop: 'Spacing-32',
  skeletonAnimationFromColor: 'Neutral-fill-2',
  skeletonAnimationToColor: 'Neutral-fill-3',
};

export default skeletonTokens;
